import { expressionDefinitionApiV2, rateLockTermsCriteriaApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const RATE_LOCK_TERMS_CRITERIA_ACTION_TYPE = createNamedActions('rateLockTerms', {
  GET_CRITERIA: 'GET_CRITERIA',
  GET_CRITERIA_SCHEMA: 'GET_CRITERIA_SCHEMA',
  CREATE_CRITERIA: 'CREATE_CRITERIA',
  EDIT_CRITERIA: 'EDIT_CRITERIA',
  DELETE_CRITERIA: 'DELETE_CRITERIA',
});

const criteria = new schema.Entity('criteria', {}, { idAttribute: 'lockTermCriteriaId' });

export const getRateLockTermsCriteriaAction = catchAsyncActionError(
  ({ snapshotId }) =>
    async dispatch => {
      const { data } = await rateLockTermsCriteriaApi.getCriteria({ snapshotId });

      return dispatch({
        type: RATE_LOCK_TERMS_CRITERIA_ACTION_TYPE.GET_CRITERIA,
        payload: normalize(data, [criteria]).entities.criteria,
      });
    },
);

export const createRateLockTermsCriteriaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await rateLockTermsCriteriaApi.createCriteria(params);

  return dispatch({
    type: RATE_LOCK_TERMS_CRITERIA_ACTION_TYPE.CREATE_CRITERIA,
    payload: data,
  });
});

export const editRateLockTermsCriteriaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await rateLockTermsCriteriaApi.editCriteria(params);

  return dispatch({
    type: RATE_LOCK_TERMS_CRITERIA_ACTION_TYPE.EDIT_CRITERIA,
    payload: data,
  });
});

export const deleteRateLockTermsCriteriaAction = catchAsyncActionError(params => async dispatch => {
  await rateLockTermsCriteriaApi.deleteCriteria(params);

  return dispatch({
    type: RATE_LOCK_TERMS_CRITERIA_ACTION_TYPE.DELETE_CRITERIA,
    meta: params,
  });
});

export const getRateLockTermsSchemaParamsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await expressionDefinitionApiV2.getRateLockTermsExpressionDefinition();

  return dispatch({
    type: RATE_LOCK_TERMS_CRITERIA_ACTION_TYPE.GET_CRITERIA_SCHEMA,
    payload: data,
  });
});
